import React from "react";

function ContactList({ address }) {
  return (
    <li className="contact-item" key={address.type}>
      <div>{address.icon}</div>
      <div>
        <h3 className="contact-item-title">{address.type}</h3>

        {address.url ? (
          <a href={address.url}>
            <address className="contact-item-link">{address.data}</address>
          </a>
        ) : (
          <a href="#contact">
            <address className="contact-item-link">{address.data}</address>
          </a>
        )}
      </div>
    </li>
  );
}

export default ContactList;
